<template>
  <div class="messages-wrapper">
    <div class="message-container">
      <div class="input-container">
        <BaseTextareaInput
          :placeholder="$t('message.messagesPage.placeholder')"
          :name="'supportMessage'"
          :validate-rules="'supportMessage'"
          v-model="message"
          :default-value="message"
        />
      </div>
      <div class="btns-block">
        <div class="btn-container">
          <base-button
            :text="$t('message.messagesPage.btn')"
            :disabled="isBtnDisabled"
            @click="sendMessage()"
          />
        </div>
        <div class="uploader-block">
          <DocsUploader
            :name="'messageFile'"
            @file="addFile"
            :clean-file="cleanFile"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextareaInput from '../components/base/BaseTextareaInput.vue';
import BaseButton from '../components/base/BaseButton.vue';
import DocsUploader from '../components/common/DocsUploader.vue';

export default {
  name: 'Messages',
  inject: ['$httpService'],
  components: {
    BaseTextareaInput,
    BaseButton,
    DocsUploader
  },
  data() {
    return {
      message: '',
      file: undefined,
      cleanFile: false
    }
  },
  methods: {
    addFile(file) {
      this.file = file;
    },
    async sendMessage() {
      const payload = new FormData();

      payload.append('message', this.message);

      if (this.file) {
        payload.append('file', this.file);
      }

      try {
        this.$httpService.message.sendMessage(payload);
        this.$toast({text: this.$t('message.messagesPage.tostMsg')});
        this.message = '';
        this.file = undefined; 
        this.cleanFile = !this.cleanFile;
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    isHasEmptyFields() {
      return !this.message;
    },
    isHasErrors() {
      return this.errors.items.length > 0;
    },
    isBtnDisabled() {
      return this.isHasEmptyFields || this.isHasErrors;
    }
  }
}
</script>

<style lang="scss" scoped>
  .messages-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 40px;
    box-sizing: border-box;
  }

  .message-container {
    @include base-page-container;

    flex-direction: column;
    color: #121212;
  }

  .input-container{
    margin-bottom: 30px;
    width: 50%;
  }

  .btns-block {
    width: 50%;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
  }

  .btn-container {
    width: 275px;
    height: 60px;
  }

  .uploader-block {
    width: 300px;
    max-width: 90%;
  }

  @media screen and (max-width: 1760px) {
    .input-container,
    .btns-block {
      width: 80%;
    }
  }

  @media screen and (max-width: 965px) {
    .input-container,
    .btns-block {
      width: 100%;
    }
  }

  @media screen and (max-width: 690px) {
    .btns-block {
      flex-direction: column-reverse;
    }
  }
</style>